var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftRight = function SvgLeftRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D4E6D",
    fillRule: "evenodd",
    d: "M6.47 3.138a.667.667 0 1 0-.942-.942L2.86 4.862a.667.667 0 0 0 0 .943l2.667 2.667a.667.667 0 1 0 .943-.943L4.942 6h7.724a.667.667 0 1 0 0-1.333H4.942l1.529-1.529Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D4E6D",
    fillRule: "evenodd",
    d: "M9.53 8.471a.667.667 0 1 1 .942-.942l2.667 2.666a.667.667 0 0 1 0 .943l-2.667 2.667a.667.667 0 1 1-.943-.943l1.529-1.529H3.334a.667.667 0 1 1 0-1.333h7.724L9.529 8.471Z",
    clipRule: "evenodd"
  })));
};
export default SvgLeftRight;